const cleanUrlProtocol = (inputUrl) => {
    const CLEAN_INPUT_URL = inputUrl;
    if (!CLEAN_INPUT_URL.startsWith('http://') && !CLEAN_INPUT_URL.startsWith('https://')) {
        return `https://${CLEAN_INPUT_URL}`;
    }
    return CLEAN_INPUT_URL;
};
const parseIntoURL = (inputUrl) => {
    let url;
    try {
        url = new URL(inputUrl);
    }
    catch {
        return undefined;
    }
    url.hash = '';
    url.username = '';
    url.password = '';
    return url.toString();
};
// checks if the string contains only numbers.
const isStringOfNumbers = (value) => (/^\d+$/u).test(value);
export const cleanUrlPath = (inputUrl) => {
    // Has to be checked here because parseIntoUrl wouldn't throw an error for a string of numbers. Number trigger a weird behavior where it keeps loading.
    if (isStringOfNumbers(inputUrl)) {
        return undefined;
    }
    const PROTOCOL_CLEANED_URL = cleanUrlProtocol(inputUrl);
    const CLEAN_URL = parseIntoURL(PROTOCOL_CLEANED_URL);
    if (CLEAN_URL === undefined) {
        return undefined;
    }
    return CLEAN_URL;
};
